<mat-form-field [color]="color" [appearance]="appearance" [floatLabel]="floatLabel">
  @if (label) {
    <mat-label>{{label}}</mat-label>
  }
  <mat-select
    [multiple]="multiple"
    [formControl]="control"
    [placeholder]="placeholder"
    [matTooltip]="getTooltipString()"
    [matTooltipClass]="'field-tooltip'"
    [matTooltipPosition]="toolTipPosition"
    [required]="required"
    (closed)="onSelectionChange()">
    @if (multiple) {
      <mat-select-trigger>
        @if ((control.value?.length || 0) === 1) {
          <span>
            {{control.value?.[0].Description || ''}}
          </span>
        }
        @if ((control.value?.length || 0) > 1 && (control.value?.length) == options.length) {
          <span>
            All
          </span>
        }
        @if ((control.value?.length || 0) > 1 && (control.value?.length) < options.length) {
          <span>
            Multiple
          </span>
        }
        @if ((control.value?.length || 0) > 1) {
          <span>
            ({{getSelectCount()}})
          </span>
        }
      </mat-select-trigger>
    }

    <mat-option>
      <ngx-mat-select-search
        placeholderLabel="search..."
        noEntriesFoundLabel="No Actions Found"
        [id]="'filter-' + controlName"
        [formControl]="filterControl"
        [showToggleAllCheckbox]="multiple"
        [toggleAllCheckboxChecked]="allToggled"
        [toggleAllCheckboxIndeterminate]="indeterminateToggle"
      (toggleAll)="allOptionClicked($event)"></ngx-mat-select-search>
    </mat-option>

    @for (option of filteredOptions | async; track option) {
      <mat-option
        #item
        [value]="option"
        (click)="toggleSelection(item, option)">
        {{option.Description}}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
